import { monthDelete } from "../user/actions";
import { MONTH_DELETE_FAIL, MONTH_DELETE_REQUEST } from "../user/actionType";
import axios from "./utils/axios";

const fetchDeleteMonth = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: MONTH_DELETE_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.delete(
        `api/common/month/delete/${id}/`,
        config
      );
      dispatch(monthDelete(data));
    } catch (error) {
      dispatch({
        type: MONTH_DELETE_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchDeleteMonth;
